import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-4 col-sm-12 col-xs-12 mb-3" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["data-src"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.card.Url,
      class: "card"
    }, [
      _createElementVNode("img", {
        "data-src": _ctx.card.ImageUrl,
        src: "https://static.cityofboise.net/images/citywide/defaultCardImage_350x250.jpg",
        alt: "",
        class: "card-img-top lazy"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.card.Title), 1),
        _createElementVNode("address", _hoisted_6, _toDisplayString(_ctx.card.Description), 1)
      ])
    ], 8, _hoisted_2)
  ]))
}